<label class="checkbox-wrapper" [class.disable-btn]="isDisabled" (click)="$event.stopPropagation()">
  <input type="checkbox"
         [checked]="value"
         [indeterminate]="isIndeterminate"
         [disabled]="isDisabled"
         (change)="change($event)"/>
  <span [class.horizontal]="labelPosition === 'horizontal'"
        [class.vertical]="labelPosition === 'vertical'">
    <span class="checkbox"
          [class.selected]="value || isIndeterminate"
          [class.icon-tick-16]="value && !isIndeterminate"
          [class.icon-minus-16]="isIndeterminate"></span>
    <span>
      <i [class]="iconClass"></i>
      <span class="text" *ngIf="label"> {{label}}</span>
    </span>
  </span>

</label>
